export const SEARCH_EXPERIENCE_COOKIE = 'awaze_beta_search_experience'

const BETA_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180

/** Set per environment in the infra task definitions; anything but "true" disables. */
export const isSearchBetaEnabled = (value: string | undefined): boolean =>
  value === 'true'

/** Access must never grant rollout eligibility. */
export const isSearchBetaEligible = ({
  enabled,
  brand,
  locale,
  brands = 'cottages.com',
}: {
  enabled: boolean
  brand: string
  locale: string
  brands?: string
}): boolean =>
  enabled &&
  /^en(?:-|$)/i.test(locale) &&
  brands
    .split(',')
    .map((value) => value.trim())
    .includes(brand)

/** The URL param enters the beta; the cookie keeps users in it until they exit. */
export const hasSearchBetaAccess = (
  searchBeta: string | string[] | undefined,
  accessCookie: string | undefined,
): boolean => searchBeta === 'true' || accessCookie === 'beta'

const writeAccessCookie = (value: string, maxAge: number): void => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${SEARCH_EXPERIENCE_COOKIE}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
}

export const persistSearchBetaAccess = (): void => {
  if (globalThis.window === undefined) return
  writeAccessCookie('beta', BETA_COOKIE_MAX_AGE_SECONDS)
}

export const clearSearchBetaAccess = (): void => {
  if (globalThis.window === undefined) return
  writeAccessCookie('', 0)
}
